
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useManufacturers() {
  const { data: masterData, refetch: refetchMaster } = useQuery({
    queryKey: ["vehicledb_master"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vehicledb_master")
        .select("manufacturer_name, manufacturer_id, maker_id, activated, market, ranking")
        .order("manufacturer_name");
      if (error) throw error;
      return data || [];
    },
  });

  const { data: adData } = useQuery({
    queryKey: ["vehicledb_ad"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vehicledb_ad")
        .select("manufacturer_name, manufacturer_id, maker_id, market, ranking")
        .order("manufacturer_name");
      if (error) throw error;
      return data || [];
    },
  });

  const { data: atpData } = useQuery({
    queryKey: ["vehicledb_atp"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vehicledb_atp")
        .select("manufacturer_name, manufacturer_id, maker_id, market, ranking")
        .order("manufacturer_name");
      if (error) throw error;
      return data || [];
    },
  });

  return { masterData, adData, atpData, refetchMaster };
}
